/**
 * ScribePageVisibilityTracker
 *
 * This module is reponsible for sending page visbility states to Scribe.
 *
 * @module    scribe_page_visibility_tracker
 * @author    Brian LaMattina <blamattina@wayfair.com>
 * @copyright 2016 Wayfair, LLC - All rights reserved
 */
import _ from 'underscore';
import SCRIBE_EVENTS from './scribe_event_constants';
import Visibility from './visibility';

/**
 * Construct a ScribePageVisibilityTracker
 *
 * @class
 * @param {ScribeClient} client a scribe client to transmit data with
 */
class ScribePageVisibilityTracker {
  // Used to map page visibility states to Scribe Events
  STATE_TO_SCRIBE_EVENT = {
    prerender: SCRIBE_EVENTS.PRERENDER,
    hidden: SCRIBE_EVENTS.PAGE_HIDDEN,
  };

  DEBOUNCE_WAIT_TIME_MS = 10; // debounce wait time in milliseconds

  constructor(client) {
    // Legacy Browsers (IE8-IE9) will can fire visibility events twice.
    // Debouncing is a stop gap.
    this._debouncedClientSendEvent = _(client.sendEvent.bind(client)).debounce(
      this.DEBOUNCE_WAIT_TIME_MS,
      true
    );
  }

  trackPrerendering() {
    const isPrerendering = Visibility.state() === 'prerender';
    if (isPrerendering) {
      this._sendVisibilityState();
    }
  }

  trackVisibilityChanges() {
    Visibility.change(this._sendVisibilityState.bind(this));
  }

  _sendVisibilityState = function() {
    const state = Visibility.state();
    if (this.STATE_TO_SCRIBE_EVENT[state]) {
      this._debouncedClientSendEvent({
        eventType: this.STATE_TO_SCRIBE_EVENT[state],
      });
    }
  };
}

export default ScribePageVisibilityTracker;
